// Enhanced OS detection with better version detection
export const detectOS = (): string => {
  const userAgent = navigator.userAgent || 'unknown';
  return getOSInfo(userAgent);
};

export const getOSInfo = (userAgent: string): string => {
  // For debugging/development
  if (import.meta.env.DEV) {
    console.log("Analyzing OS from UA:", userAgent);
  }

  // Normalize user agent for case-insensitive matching
  const ua = userAgent.toLowerCase();
  
  // Android with version detection - enhanced pattern matching for different formats
  if (ua.includes('android')) {
    // Try different patterns for Android version
    const androidVersionPatterns = [
      /android (\d+)(?:\.(\d+))?/,
      /android\/(\d+)(?:\.(\d+))?/
    ];
    
    for (const pattern of androidVersionPatterns) {
      const match = ua.match(pattern);
      if (match) {
        const major = match[1];
        const minor = match[2] || "0";
        return `Android ${major}${minor ? "." + minor : ""}`;
      }
    }
    return 'Android'; // Return generic Android if version can't be determined
  }
  
  // Windows with version detection
  if (ua.includes('windows nt 10.0')) return 'Windows 10/11';
  if (ua.includes('windows nt 6.3')) return 'Windows 8.1';
  if (ua.includes('windows nt 6.2')) return 'Windows 8';
  if (ua.includes('windows nt 6.1')) return 'Windows 7';
  if (ua.includes('windows nt 6.0')) return 'Windows Vista';
  if (ua.includes('windows nt 5.1')) return 'Windows XP';
  if (ua.includes('windows nt')) return 'Windows';
  
  // macOS detection with version patterns
  if (ua.match(/mac os x (\d+)[_.](\d+)/)) {
    const match = ua.match(/mac os x (\d+)[_.](\d+)/);
    if (match) {
      const majorVersion = parseInt(match[1]);
      const minorVersion = parseInt(match[2]);
      
      if (majorVersion >= 10 && minorVersion >= 15) {
        return 'macOS Catalina+';
      } else if (majorVersion >= 10) {
        return 'macOS';
      }
    }
  }
  if (ua.includes('mac os x')) return 'macOS';
  
  // Linux distributions
  if (ua.includes('ubuntu')) return 'Ubuntu Linux';
  if (ua.includes('fedora')) return 'Fedora Linux';
  if (ua.includes('debian')) return 'Debian Linux';
  if (ua.includes('centos')) return 'CentOS Linux';
  if (ua.includes('suse')) return 'SUSE Linux';
  if (ua.includes('linux')) return 'Linux';
  
  // iOS with version detection
  if (ua.includes('iphone') || ua.includes('ipad') || ua.includes('ipod')) {
    const match = ua.match(/os (\d+)_(\d+)(?:_(\d+))?/);
    if (match) {
      return `iOS ${match[1]}.${match[2]}${match[3] ? '.' + match[3] : ''}`;
    }
    return 'iOS';
  }
  
  // Other mobile operating systems
  if (ua.includes('blackberry') || ua.includes('bb10')) return 'BlackBerry OS';
  if (ua.includes('windows phone')) return 'Windows Phone';
  
  // Game consoles and other devices
  if (ua.includes('playstation')) return 'PlayStation';
  if (ua.includes('xbox')) return 'Xbox';
  if (ua.includes('nintendo')) return 'Nintendo';
  
  // For debugging/development
  if (import.meta.env.DEV && !ua.includes('unknown')) {
    console.warn("Unrecognized OS UA:", userAgent);
  }
  
  return 'Other';
};
